import styled from 'styled-components';
import { device, spacing } from 'commons';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  padding: 0 ${spacing.detailsSidePadding} 100px ${spacing.detailsSidePadding};

  @media (max-width: ${device.mobile}px) {
    padding: 0 32px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 40px 0 56px;
`;
